import { useEffect as e } from "react";
import { useFormContext as t, useWatch as n } from "react-hook-form";
import { LocalDbTypeEnum as r } from "@vintecc/capture-api-types/v2";
//#region src/hooks/shared/useAnalyticsAvailability.ts
var i = () => {
	let { control: i, setValue: a, getValues: o } = t(), s = n({
		control: i,
		name: "localDatabaseConfig"
	})?.some((e) => e.type === r.Influx) ?? !1;
	return e(() => {
		o("analyticsSettings.enabled") !== s && a("analyticsSettings.enabled", s, {
			shouldDirty: !1,
			shouldValidate: !0
		});
	}, [
		s,
		a,
		o
	]), s;
};
//#endregion
export { i as t };

//# sourceMappingURL=useAnalyticsAvailability-CIyTIZUn.js.map